export const ACCEPTED_TYPES = ["image/jpeg", "image/png", "image/gif", "image/bmp", "image/webp"];
export const IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif", "image/bmp", "image/webp"];
